import { Button, Flex, Spacer, VStack } from '@chakra-ui/react';
import PluginEditor from '@draft-js-plugins/editor';
import * as React from 'react';

import { AttachmentButton } from './components/AttachmentButton';
import { AttachmentPreview } from './components/AttachmentPreview';
import { Body } from './components/Body';
import { ImageButton } from './components/ImageButton';
import { ImagePreview } from './components/ImagePreview';

export const CommentForm = React.forwardRef<
  PluginEditor,
  {
    onSubmit: () => void;
    mentionData?: { _id: string; postId: string; displayName: string };
    onClickCancel: () => void;
    submitButtonText: string;
    isSubmitting: boolean;
  }
>(
  (
    { onSubmit, mentionData, onClickCancel, submitButtonText, isSubmitting },
    ref
  ) => {
    return (
      <VStack width="full" spacing="2">
        <VStack spacing="2" width="full">
          <Body
            validationMessage="A comment must be provided"
            placeholder="Write a comment..."
            ref={ref}
            mentionData={mentionData}
          />
          <ImagePreview />
          <AttachmentPreview />
        </VStack>
        <Flex width="full">
          <AttachmentButton mr="2" attachmentLimit={10} />
          <ImageButton imageLimit={20} />
          <Spacer />
          <Button
            variant="ghost"
            size="sm"
            colorScheme="gray"
            onClick={onClickCancel}
            mr="2"
          >
            Cancel
          </Button>
          <Button
            onClick={onSubmit}
            size="sm"
            onMouseDown={(e) => e.preventDefault()}
            isLoading={isSubmitting}
          >
            {submitButtonText}
          </Button>
        </Flex>
      </VStack>
    );
  }
);

CommentForm.displayName = 'CommentForm';
